export const METAL_ROOF_METAL_ROOFING_CHARACTERISTICS_LIST = [
  {
    name: 'Срок эксплуатации',
    value: 'До 50 лет',
  },
  {
    name: 'Огнестойкость',
    value:
      'Огнестойкий материал. Не\u00A0воспламеняется и\u00A0не\u00A0поддерживает горение. Изготовлен из\u00A0оцинкованной стали с\u00A0полимерным покрытием',
  },
  {
    name: 'Устойчивость материала',
    value:
      'Металлочерепица устойчива к\u00A0высоким и\u00A0низким температурам: не\u00A0деформируется и\u00A0не\u00A0трескается, сохраняя эксплуатационные качества',
  },
  {
    name: 'Простота в использовании',
    value:
      'Металлочерепица проста в\u00A0уходе: периодически удаляйте снег и\u00A0мусор. Один раз в\u00A0год осматривайте крышу на\u00A0наличие повреждений и\u00A0трещин. Между листами не\u00A0должно быть зазоров, иначе в\u00A0них будет попадать вода',
  },
  {
    name: 'Особенности монтажа',
    value:
      'Подходит для всех типов скатных кровель. Можно использовать на\u00A0крышах с\u00A0любым уклоном. Упрощенный монтаж и\u00A0возможность сэкономить на\u00A0стропильной системе',
  },
  {
    name: 'Цвет и внешний вид',
    value: 'Металлочерепица имеет большой выбор цветов и\u00A0имитирует керамическую черепицу',
  },
  {
    name: 'Шум кровли',
    value:
      'Шумит во\u00A0время дождя. Особенность материала можно устранить с\u00A0помощью минераловатной тепло-шумоизоляции',
  },
];

export const METAL_ROOF_ROOFING_CORRUGATED_SHEET_CHARACTERISTICS_LIST = [
  {
    name: 'Срок эксплуатации',
    value: 'До 50 лет',
  },
  {
    name: 'Огнестойкость',
    value:
      'Огнестойкий материал. Не\u00A0воспламеняется и\u00A0не\u00A0поддерживает горение. Изготовлен из\u00A0оцинкованной стали с\u00A0полимерным покрытием',
  },
  {
    name: 'Устойчивость материала',
    value:
      'Кровельный профнастил устойчив к\u00A0высоким и\u00A0низким температурам: не\u00A0деформируется и\u00A0не\u00A0трескается, сохраняя эксплуатационные качества',
  },
  {
    name: 'Простота в использовании',
    value:
      'Кровельный профнастил прост в\u00A0уходе: периодически удаляйте снег и\u00A0мусор. Один раз в\u00A0год осматривайте крышу на\u00A0наличие повреждений и\u00A0трещин. Между листами не\u00A0должно быть зазоров, иначе в\u00A0них будет попадать вода',
  },
  {
    name: 'Особенности монтажа',
    value: 'Подходит для всех типов скатных кровель. Можно использовать на\u00A0крышах с\u00A0любым уклоном',
  },
  {
    name: 'Установка и доставка',
    value: 'Небольшой удельный вес упрощает монтаж и\u00A0снижает затраты на\u00A0стропильную систему',
  },
  {
    name: 'Шум кровли',
    value:
      'Шумит во\u00A0время дождя. Особенность материала можно устранить с\u00A0помощью минераловатной тепло-шумоизоляции',
  },
];

export const METAL_ROOF_SEAM_ROOFING_CHARACTERISTICS_LIST = [
  {
    name: 'Срок эксплуатации',
    value: 'До 50 лет',
  },
  {
    name: 'Огнестойкость',
    value:
      'Огнестойкий материал. Не\u00A0воспламеняется и\u00A0не\u00A0поддерживает горение. Изготовлен из\u00A0оцинкованной стали с\u00A0полимерным покрытием',
  },
  {
    name: 'Устойчивость материала',
    value:
      'Фальцевая кровля устойчива к\u00A0высоким и\u00A0низким температурам: не\u00A0деформируется и\u00A0не\u00A0трескается, сохраняя эксплуатационные качества',
  },
  {
    name: 'Простота в использовании',
    value:
      'Фальцевая кровля проста в\u00A0уходе: периодически удаляйте снег и\u00A0мусор, а\u00A0также промывайте поверхность кровли водой из\u00A0шланга',
  },
  {
    name: 'Особенности монтажа',
    value: 'Подходит для всех типов скатных кровель. Можно использовать на\u00A0крышах с\u00A0любым уклоном',
  },
  {
    name: 'Цвет и внешний вид',
    value: 'Разнообразие цветов и\u00A0нарезки. Позволяет воплотить практически любое дизайнерское решение',
  },
  {
    name: 'Шум кровли',
    value: 'Шумит во\u00A0время дождя. Особенность материала можно устранить с\u00A0помощью теплоизоляции',
  },
];

export const METAL_ROOF_FLEXIBLE_SHINGLES_CHARACTERISTICS_LIST = [
  {
    name: 'Срок эксплуатации',
    value: 'До 50 лет',
  },
  {
    name: 'Стойкость к выцветанию',
    value: 'Природные материалы верхнего слоя не\u00A0изменяют свой цвет на\u00A0солнце',
  },
  {
    name: 'Особенности монтажа',
    value:
      'Укладка производится при температуре от\u00A0+5\u00A0до\u00A0+10℃, в\u00A0отсутствие дождя и\u00A0высокой влажности, чтобы избежать гниения основания материала',
  },
  {
    name: 'Градус ската крыши',
    value:
      'Подходит для всех скатных кровель с\u00A0наклоном от -12\u00B0C до\u00A045\u00B0C. Оптимальный угол\u00A0\u2014 от\u00A018,5\u00B0C до\u00A060\u00B0C\u00A0с максимумом в\u00A030\u00B0C. За\u00A0счет гибкости гонтов, черепица легко крепится к\u00A0любой форме кровли при минимальном угле ската в\u00A011\u00B0C',
  },
  {
    name: 'Цвет и внешний вид',
    value: 'Разнообразие цветов и\u00A0нарезки. Позволяет воплотить практически любое дизайнерское решение',
  },
  {
    name: 'Шум кровли',
    value:
      'Высокая шумоизоляция. Крыша из\u00A0мягкой черепицы не\u00A0побеспокоит владельцев шумом дождя или скрежетом когтей птиц',
  },
];

export const METAL_ROOF_ONDULIN_CHARACTERISTICS_LIST = [
  {
    name: 'Срок эксплуатации',
    value: 'До 20 лет',
  },
  {
    name: 'Цена',
    value: 'Самый дешевый кровельный материал',
  },
  {
    name: 'Стойкость цвета',
    value:
      'В\u00A0течение одного-двух сезонов после монтажа под воздействием снега, дождя, солнца, слой битумной плёнки с\u00A0поверхности материала постепенно удаляется и\u00A0кровля становится светлее, визуально чище, и\u00A0на\u00A0этом стабилизируется',
  },
  {
    name: 'Особенности монтажа',
    value:
      'Ондулин может использоваться на\u00A0облегченных стропильных системах благодаря своему низкому весу',
  },
  {
    name: 'Устойчивость материала',
    value:
      'Ондулиновое покрытие имеет низкую стойкость к\u00A0продавливанию, поэтому по\u00A0нему нельзя ходить. Также материал становится хрупким на\u00A0морозе и\u00A0размягчается на\u00A0солнцепеке',
  },
  {
    name: 'Доставка',
    value:
      'Ондулин легко транспортируется на\u00A0легковом автомобиле и\u00A0просто поднимается на\u00A0крышу',
  },
  {
    name: 'Цвет и внешний вид',
    value: 'Ондулин имитирует классическую керамическую черепицу',
  },
  {
    name: 'Шум кровли',
    value: 'Кровля из\u00A0ондулина тихая и\u00A0не\u00A0шумит во\u00A0время дождя',
  },
];

export const METAL_ROOF_CHARACTERISTICS_MAP: Record<string, Record<string, string>[]> = {
  metallocherepica: METAL_ROOF_METAL_ROOFING_CHARACTERISTICS_LIST,
  profnastil: METAL_ROOF_ROOFING_CORRUGATED_SHEET_CHARACTERISTICS_LIST,
  falcevaya: METAL_ROOF_SEAM_ROOFING_CHARACTERISTICS_LIST,
  'gibkaya-cherepitsa': METAL_ROOF_FLEXIBLE_SHINGLES_CHARACTERISTICS_LIST,
  ondulin: METAL_ROOF_ONDULIN_CHARACTERISTICS_LIST,
};
